import { Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { L10nLocale, L10N_LOCALE } from 'angular-l10n';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BaseService } from 'src/app/core/services/base.service';
import { MessageBusService } from 'src/app/core/services/message-bus.service';
import { ComponentLookup } from 'src/app/shared/decorators/component-lookup.decorator';
import { IControlComponent } from 'src/app/shared/interfaces/control-component';
import { FormComponentData } from 'src/app/shared/models/people/form-control.model';
import { PositionPublicProfile, PublicProfile, PublicProfileDetailLightweight } from 'src/app/shared/models/people/public-profile.model';

@Component({
  selector: 'app-profile-career-path',
  templateUrl: './career-path.component.html',
  styleUrls: ['./../../styles/public-profile.css', './career-path.component.css'],
  encapsulation: ViewEncapsulation.None
})
@ComponentLookup('ProfileCareerPathComponent')
export class CareerPathComponent implements OnInit, OnDestroy, IControlComponent  {
  
  data: FormComponentData;
  private ngUnsubscribe = new Subject();
  publicProfile: PublicProfile;
  finishLoading: boolean = false;
  showCard: boolean = true;

  constructor(
    protected messageBusService: MessageBusService,
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    protected baseService: BaseService,
  ) {}

  ngOnInit(): void {
    this.messageBusService.onSendPublicProfile()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(message => {
        this.publicProfile = message.publicProfile;
        
        this.setShowCard();

        this.finishLoading = true;
      });

    this.baseService.sendComponentFinishLoadingMessage(this.data);
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  setShowCard() {
    this.showCard = (!this.isArrayNullOrEmpty(this.publicProfile.licenses)
        || !this.isArrayNullOrEmpty(this.publicProfile.affiliations)
        || !this.isArrayNullOrEmpty(this.publicProfile.positions));
  }

  isArrayNullOrEmpty(array: Array<any>) {
    return !(array && array.length > 0);
  }

  getFormatedDate(educationItem: PositionPublicProfile) {
    var getStr = (str:string) => str ? str : "";

    var startMonth = getStr(educationItem.mesInicio);
    var endMonth = getStr(educationItem.mesFin);    

    if (startMonth)
        startMonth = this.baseService.getMonthName(parseInt(startMonth), true);

    if (endMonth)
        endMonth = this.baseService.getMonthName(parseInt(endMonth), true);

    var start = (startMonth + " " + getStr(educationItem.anioInicio)).trim();
    var end = (endMonth + " " + getStr(educationItem.anioFin)).trim();

    if (start && end)
        return start + " - " + end;
    else
        return start ? start : end;
    
    return "";
  }

  getDetailsAsString = function(details: PublicProfileDetailLightweight[]) {
    return details.map(d => d.objetoDetalle).join(", ");
  };
}
